export enum Color {
  BLUE_DARK = '#071E59',
  BLUE_LIGHT = '#96DCFF',
  BLUE_FAINT = 'rgb(220, 240, 255)',
  OFF_WHITE = 'rgb(230, 234, 242)',
  DANGER = '#dc3546',
  DARK = '#212529',
  DARK_BLUE = '#131921',
  GRAY_DARKEST = '#222222',
  GRAY_DARK = '#444444',
  GRAY_LIGHT = '#dddddd',
  GRAY_FAINT = '#f2f2f2',
  GRAY_MEDIUM = '#777777',
  GRAYISH_BLUE = '#6ec9fa',
  LIGHT = '#f8f9fa',
  LIGHT_YELLOW = '#ffffe0',
  MEDIUM_BLUE = '#289eff',
  PRIMARY = '#0d6dfd',
  SECONDARY = '#6c757d',
  TRANSPARENT = 'transparent',
  WHITE = '#ffffff',
}
